import {
	ExperienceName,
	PreviewCardRenderDiagnosticAttribute,
} from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

export const abortPreviewCardRenderExperience = ({
	experienceTracker,
	reason,
	terminalReason,
	attributes = {},
}: {
	experienceTracker: ExperienceTrackerAPI;
	reason: string;
	terminalReason: 'awaiting-disambiguation' | 'user-cancelled';
	attributes?: Record<string, unknown>;
}): void => {
	experienceTracker.abort({
		name: ExperienceName.PREVIEW_CARD_RENDER,
		reason,
		checkForTimeout: false,
		attributes: {
			...attributes,
			[PreviewCardRenderDiagnosticAttribute.TERMINAL_REASON]: terminalReason,
		},
	});
};
